import { render, staticRenderFns } from "./RecommendOrganization.vue?vue&type=template&id=8f01b010&"
import script from "./RecommendOrganization.vue?vue&type=script&lang=ts&"
export * from "./RecommendOrganization.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports